import { render, staticRenderFns } from "./Disconnect.vue?vue&type=template&id=36d21bbe&scoped=true&"
import script from "./Disconnect.vue?vue&type=script&lang=js&"
export * from "./Disconnect.vue?vue&type=script&lang=js&"
import style0 from "./Disconnect.vue?vue&type=style&index=0&id=36d21bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d21bbe",
  null
  
)

export default component.exports